// extracted by mini-css-extract-plugin
module.exports = {"AccountHero":"styles_AccountHero__HTotJ","wrapper":"styles_wrapper__j2PdL"};